// extracted by mini-css-extract-plugin
export default {"grid":"product_grid__raygq","menu":"product_menu__sJXMp","catagary":"product_catagary__-V8Od","P":"product_P__PfaBU","H":"product_H__YdLnr","viewsshow":"product_viewsshow__U1pKb"};